var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimerDoneIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1556",
    "data-name": "Rectangle 1556",
    width: 20,
    height: 20,
    transform: "translate(0.405 0.406)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1552",
    "data-name": "Rectangle 1552",
    width: 17.846,
    height: 17.846,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1554",
    "data-name": "Rectangle 1554",
    width: 17.587,
    height: 17.593,
    fill: "#1450ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Timer_done",
    "data-name": "Timer done",
    transform: "translate(9.054 0.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4601",
    "data-name": "Group 4601",
    transform: "translate(-9.459 -0.459)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4600",
    "data-name": "Group 4600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4599",
    "data-name": "Group 4599",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4591",
    "data-name": "Group 4591",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4590",
    "data-name": "Group 4590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4589",
    "data-name": "Group 4589",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1549",
    "data-name": "Rectangle 1549",
    width: 20,
    height: 20,
    transform: "translate(0.405 0.406)",
    fill: "#ffe4e4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4594",
    "data-name": "Group 4594",
    transform: "translate(1.28 1.28)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4593",
    "data-name": "Group 4593"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4592",
    "data-name": "Group 4592",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1551",
    "data-name": "Rectangle 1551",
    width: 17.846,
    height: 17.846
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1712",
    "data-name": "Path 1712",
    d: "M6.656,17.351c-.007.007,0,.007,0,.015l0-.015Z",
    transform: "translate(-0.787 -2.808)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4598",
    "data-name": "Group 4598",
    transform: "translate(1.573 1.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4597",
    "data-name": "Group 4597",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4596",
    "data-name": "Group 4596"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4595",
    "data-name": "Group 4595",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1713",
    "data-name": "Path 1713",
    d: "M18.948,10.695c-.021.152-.037.305-.064.457a.853.853,0,0,1-1.694-.144c0-.269.037-.537.04-.805A7.076,7.076,0,1,0,9.063,17.11a6.99,6.99,0,0,0,4.808-.973.941.941,0,0,1,.647-.172.85.85,0,0,1,.727.681.839.839,0,0,1-.389.9A8.793,8.793,0,1,1,8.487,1.482c.368-.072.745-.111,1.117-.165h1.168c.3.044.609.08.913.133a8.784,8.784,0,0,1,7.127,7.129c.054.315.092.632.136.948Z",
    transform: "translate(-1.361 -1.317)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1714",
    "data-name": "Path 1714",
    d: "M9.933,12.593a1.2,1.2,0,0,1,.119-.178q1.965-1.969,3.933-3.934a.859.859,0,0,1,1.33,1.089,1.049,1.049,0,0,1-.08.089q-2.361,2.362-4.722,4.723a.845.845,0,0,1-1.231,0q-1.068-1.056-2.124-2.124a.858.858,0,1,1,1.212-1.215c.466.456.924.921,1.386,1.382.043.044.089.085.178.168",
    transform: "translate(-2.405 -2.612)",
    fill: "#1450ff"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerDoneIcon);
export default __webpack_public_path__ + "static/media/timer_done_icon.90c81a7e3fe4628e6d1a2cfd8dbb36e5.svg";
export { ForwardRef as ReactComponent };